import { useCallback } from "preact/hooks";

const useAutoResize = () => {
    const ref = useCallback((element: HTMLTextAreaElement | null) => {
        if (!element) {
            return;
        }

        element.style.height = `${element.scrollHeight}px`;
        element.style.overflowY = "hidden";
        element.addEventListener("input", () => {
            element.style.height = "0";
            element.style.height = `${element.scrollHeight}px`;
        });
    }, []);

    return ref;
};

export default useAutoResize;
